export const downloadFile = (file, fileName, extension = 'csv') => {
  const url = window.URL.createObjectURL(new Blob([file]));

  const link = document.createElement('a');

  link.href = url;
  link.setAttribute('download', `${fileName}.${extension}`);

  document.body.appendChild(link);
  link.click();

  link.remove();
};
